exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.manage-orders__details[data-v-88e48a50] {\n  max-width: 400px;\n}\n.manage-orders__row[data-v-88e48a50] {\n  cursor: pointer;\n}\n.manage-orders__table[data-v-88e48a50] {\n  margin-top: 24px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88e48a50","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/trade/index/components/manageOrders/Trade.ManageOrders.vue
// module id = qzRg
// module chunks = 1